import React from 'react';

// differentiate same-named players (e.g. multiple "Williams") the same way.
export default function formatPlayerSeasons(option: any) {
  const defaultReturn = ['-'];
  if (option === undefined || option === null) {
    return defaultReturn;
  }

  if (option.is_freshman) {
    return <span style={{ fontWeight: 600 }}>{option.last_year}</span>
  }

  // only multi-year players
  let value = `${option.first_year}`;
  if (option.last_year) {
    value = `${value}-${option.last_year}`;
  }

  if (option.is_active) {
    return <span style={{ fontWeight: 600 }}>{value}</span>
  }
  return value;
}
